import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AuthenticationGuard, AuthenticationService } from '@sla-ng/core';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SlairAuthenticationGuard extends AuthenticationGuard {
    constructor(
        protected myRouter: Router,
        protected myAuthenticationService: AuthenticationService,
    ) {
        super(myRouter, myAuthenticationService);
    }


    public canLoad(route: Route, _segments: UrlSegment[]): Observable<boolean | UrlTree> {
        return this.guardRoute(route.data);
    }

    public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.guardRoute(route.data);
    }

    private guardRoute(routeData: Data): Observable<boolean> {

        const routeRoles: string[] = routeData ? routeData[ 'roles' ] as string[] : null;

        return this.myAuthenticationService.isLoginValid().pipe(map(valid => {
            // Check if user is logged in
            if (!valid) {
                this.myAuthenticationService.login('', '');
            }
            // Check if user has required roles
            if (!this.myAuthenticationService.userHasRoles(routeRoles)) {
                return false;
            }
            return valid;
        }));

    }
}
